import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 72, height = 72, customClass='' }: IconComponentProps) => <svg width={width} height={height} viewBox="0 0 72 72" fill="none" class={customClass}>
<path d="M36 66C52.5685 66 66 52.5685 66 36C66 19.4315 52.5685 6 36 6C19.4315 6 6 19.4315 6 36C6 52.5685 19.4315 66 36 66Z" stroke="#6B707E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M36 18V36L48 42" stroke="#6B707E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

